module.exports = __webpack_public_path__ + "odinstatic/v5.0.2/media/cms-panel-active.c8b37189.svg";